module.exports = __webpack_public_path__ + "e50c9997017cf05e145a1e3b28c30426.svg";